import { handleDeployStaleAssetFailure } from "../helpers/deployStaleAssetRecovery";

export default function componentLoader(lazyComponent, attemptsLeft = 4) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        // let us retry after 1500 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            // Soft reload / cache-bust / error screen instead of hanging Suspense.
            const recovery = handleDeployStaleAssetFailure();
            if (recovery === "reloaded" || recovery === "in_flight") {
              // Leave the promise pending while the document navigates away.
              return;
            }
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(
            resolve,
            reject,
          );
        }, 1500);
      });
  });
}
